export default "__VITE_ASSET__FqbwEbOu__"